import { Component, OnInit, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';

@Component({
  selector: 'app-walkin-drive-dialogbox',
  templateUrl: './walkin-drive-dialogbox.component.html',
  styleUrls: ['./walkin-drive-dialogbox.component.scss']
})
export class WalkinDriveDialogboxComponent implements OnInit {

  walkinDriveGroup: FormGroup;

  constructor(
    public dialogRef : MatDialogRef<WalkinDriveDialogboxComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private formBuilder : FormBuilder
  ) { }

  eventTypes : string[] = ["Recurring", "One Time"];
  eventType : string = "Recurring";
  driveTypes : string[] = ['Drive1', 'Drive2', 'Drive3'];
  driveType : string;

  ngOnInit() {
    this.walkinDriveGroup = this.formBuilder.group ({
      driveName: ['', Validators.required],
      city: ['', Validators.required],
      companyName: ['', Validators.required],
      address: ['', Validators.required],
      addressUrl: ['', Validators.required],
      eventTypeName: ['', Validators.required],
      driveTypeName: ['', Validators.required],
      accessCode: ['', Validators.required],
      registrationLink: ['', Validators.required],
      startDate: ['', Validators.required],
      endDate: ['', Validators.required],
      eventDate: ['', Validators.required],
      time: ['', Validators.required],
    })
  }

  cancle(): void {
    this.dialogRef.close();
  }

  submit(): void {
    console.log("Walkin drive:",this.walkinDriveGroup.value);
  }
}
